// start:ng42.barrel
export * from './synonym.facade';
export * from './synonym.model';
// end:ng42.barrel

